// @flow
import * as React from 'react';
import Helmet from 'react-helmet';
import styled, { withTheme } from 'styled-components';
import { MuiThemeProvider } from '@material-ui/core';

import type { MessageType } from 'common/components/PageMessage';
import PageMessage from 'common/components/PageMessage';
import { MuiTheme, Stylesheet } from 'statsradio/themes/v2';
import { Title } from '../../themes/v2/Stylesheet';

const ContentWrapper = styled(Stylesheet)`
  position: relative;
  width: 100%;
`;

const StyledContainer = styled.div`
  height: 100%;
  overflow: hidden;

  min-height: calc(100vh - ${({ theme }) => theme.V2.metrics.navbar.height}px);
  display: flex;
  align-items: center;
  flex-direction: column;

  padding: ${({ theme: { V2 } }) => V2.metrics.margin.large}px;
  padding-top: ${({ theme: { V2 } }) => V2.metrics.margin.normal}px;

  @media only screen and (max-width: ${({ theme: { V2 } }) => V2.metrics.breakpoints.small}) {
    padding-bottom: ${({ theme: { V2 } }) => V2.metrics.margin.normal}px;
  }
`;

const PageWrapper = styled.div`
  width: 100%;

  max-width: ${({ isFluid, theme }) => (isFluid ? '100%' : theme.V2.metrics.page.maxWidth + 'px')};

  @media only screen and (max-width: ${({ theme: { V2 } }) => V2.metrics.breakpoints.small}) {
    max-width: 100%;
  }

  ${({ isSmall, theme: { V2 } }) => isSmall && `
    @media (min-width: ${V2.metrics.breakpoints.normal}) {
      width: 80%;
    }
  `}
`;

const Header = styled.div`
  text-align: center;

  width: 100%;
  max-width: ${({ isFluid, theme }) => (isFluid ? '100%' : theme.V2.metrics.page.maxWidth + 'px')};


  @media only screen and (max-width: ${({ theme: { V2 } }) => V2.metrics.breakpoints.small}) {
    max-width: 100%;
  }
`;

type Message = {
  message: string,
  type: MessageType,
}


type Props = {
  fluid: boolean,
  small: boolean,
  title: string,
  hideTitle?: boolean,

  messages: Message[],

  floatingComponents?: React.Node,

  children: any,
  theme: any,
  style: Object,
  className: string,
};

function PageV2({ messages, fluid, small, title, hideTitle, floatingComponents, children, theme: { V2 }, style, className }: Props) {
  return (
    <MuiThemeProvider theme={MuiTheme}>
      <ContentWrapper>
        {messages.map(({ message, type }) =>
          <PageMessage key={message + type} message={message} type={type} />)
        }
        <StyledContainer style={style} className={className}>
          <Helmet>
            <title>{title}</title>
          </Helmet>

          {floatingComponents}

          {!hideTitle &&
          <Header>
            <Title>{title}</Title>
          </Header>
          }

          <PageWrapper isFluid={fluid || false} isSmall={small || false}>
            {children}
          </PageWrapper>
        </StyledContainer>
      </ContentWrapper>
    </MuiThemeProvider>
  );
}

export default withTheme(PageV2);



// WEBPACK FOOTER //
// ./src/statsradio/components/page/PageStylesV2.js